import requests from 'api/index';

const prefixURL = '/approval/rest';
const approvalApi = {
  // 처음 관리자 등록을 위한 api
  approvalCompCreate: payload => requests.post(`${prefixURL}/v1/organization/compCreate`, payload),
};
export default approvalApi;
